export default "__VITE_PUBLIC_ASSET__3b30c0e2__"